import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import quizQuestions from '../quizQuestions';

const NormalQuizRandomScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { username } = location.state || { username: 'Guest' };

  // Compute and store 5 random questions only once.
  const [sessionQuestions] = useState(() => {
    const shuffled = [...quizQuestions].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 5);
  });

  // Component state.
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);

  // Ref to ensure auto-advance happens only once.
  const answeredRef = useRef(false);

  // Handle answer selection.
  const handleAnswer = (option) => {
    if (answeredRef.current) return; // Prevent double processing.
    answeredRef.current = true;
    setSelectedAnswer(option);

    const currentQuestion = sessionQuestions[currentQuestionIndex];
    const isCorrect = option === currentQuestion.answer;
    if (isCorrect) {
      setScore(prev => prev + 1);
    }
  };

  // Handle next question button click
  const handleNextQuestion = () => {
    if (currentQuestionIndex < sessionQuestions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
      setSelectedAnswer(null);
      answeredRef.current = false; // Reset for next question.
    } else {
      const currentQuestion = sessionQuestions[currentQuestionIndex];
      const isCorrect = selectedAnswer === currentQuestion.answer;
      const finalScore = score;
      const sessionData = {
        username,
        prototype: "Normal Random",
        score: finalScore,
      };
      navigate("/", { state: { sessionData } });
    }
  };

  const currentQuestion = sessionQuestions[currentQuestionIndex];

  return (
    <div style={styles.container}>
      <h2 style={styles.greeting}>Welcome, {username}! (Normal Random)</h2>
      <div style={styles.quizContainer}>
        <h3 style={styles.question}>{currentQuestion.question}</h3>
        {currentQuestion.options.map((option, index) => (
          <button
            key={index}
            style={{
              ...styles.optionButton,
              backgroundColor: selectedAnswer === null 
                ? "#b0c4de" 
                : option === currentQuestion.answer 
                  ? "#90ee90" // Light green for correct answer
                  : selectedAnswer === option 
                    ? option === currentQuestion.answer ? "#90ee90" : "#ffcccb" // Red if selected wrong
                    : "#b0c4de",
            }}
            onClick={() => handleAnswer(option)}
            disabled={selectedAnswer !== null}
          >
            {option}
          </button>
        ))}
        {selectedAnswer !== null && (
          <div style={styles.explanation}>
            <p style={styles.explanationTitle}>Explanation:</p>
            <p style={styles.explanationText}>{currentQuestion.explanation}</p>
            <button 
              style={styles.nextButton}
              onClick={handleNextQuestion}
            >
              {currentQuestionIndex < sessionQuestions.length - 1 ? "Next Question" : "Finish Quiz"}
            </button>
          </div>
        )}
        <p style={styles.score}>Score: {score}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
    backgroundColor: "#e6f0fa",
  },
  greeting: {
    color: "#4682b4",
    fontSize: "2rem",
  },
  quizContainer: {
    marginTop: "20px",
  },
  question: {
    fontSize: "1.5rem",
    color: "#4682b4",
  },
  optionButton: {
    display: "block",
    width: "80%",
    margin: "10px auto",
    padding: "10px",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    backgroundColor: "#b0c4de",
    color: "#333",
    transition: "background-color 0.5s ease", // Smooth animation for color change
  },
  score: {
    fontSize: "1.25rem",
    color: "#4682b4",
    marginTop: "20px",
  },
  explanation: {
    backgroundColor: "#f0f8ff", // Alice Blue
    borderRadius: "8px",
    padding: "10px 15px",
    margin: "15px auto",
    width: "80%",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    textAlign: "left",
  },
  explanationTitle: {
    fontWeight: "bold",
    color: "#4682b4",
    marginBottom: "5px",
  },
  explanationText: {
    color: "#333",
    lineHeight: "1.4",
  },
  nextButton: {
    backgroundColor: "#4682b4",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    margin: "10px 0",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "bold",
    display: "block",
    width: "100%",
  },
};

export default NormalQuizRandomScreen;
